import React, { useEffect, useState } from "react";
import ConfirmDialog from "../../../../components/actionDialogs/confirmDialog";
import Loader from "../../../../components/loader/loader";
import Snackbar from "../../../../components/snackbar/snackbar";
import CustomTable from "../../../../components/table/table";
import {
  admin_banners_list,
  admin_banner_delete,
  admin_areatype_delete,
  admin_rentarea_list,
  admin_rentarea_delete,
  admin_area_allocated_histoty_list,
} from "../../admin.api";
import ManageBanner from "./manage/manage";
import "./view.css";
import jwtDecode from "jwt-decode";
export default function RentAreaHistory(props) {
  let adminType = Number(jwtDecode(props?.state?.payload).user_type);

  const [data, setdata] = useState([]);
  const [addNew, setAddNew] = useState(false);
  const [formData, setFormData] = useState({});
  const [edit, setEdit] = useState(false);
  const [view, setView] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [rentArea, setRentArea] = useState([]);

  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  //////////
  const fetchRentArea = () => {
    setIsActive(true);
    admin_area_allocated_histoty_list()
      .then((res) => {
        const filteredData = res?.data?.filter(
          (item) => item?.application?.area_type === "built_up_space"
        ) || [];
        setRentArea(filteredData);
      })
      .finally(() => {
        setIsActive(false);
      });
  };

  useEffect(() => {
    fetchRentArea();
  }, []);
  const handleAddNew = () => {
    setAddNew(true);
    setView(false);
  };
  const handleClose = () => {
    setAddNew(false);
    setEdit(false);
    setFormData({});
    fetchRentArea();
  };
  const handleEdit = (data) => {
    setFormData(data);
    setView(false);
    setEdit(true);
    setAddNew(true);
  };
  const handleView = (data) => {
    setAddNew(true);
    setFormData(data);
    setView(true);
  };
  //for delete
  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_rentarea_delete(data?.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsActive(false);
        setIsSnackError(false);
        setSnackOpen(true);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setIsActive(false);
        setSnackOpen(true);
      });
  };
  /////////////////////
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      fetchRentArea();
    }
  };
  return (
    <div>
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Built-Up Space Allocation Details</b>
        </h6>
        <hr />
        {/* {adminType === 1 && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={(e) => handleAddNew(e)}
          >
            Add New
          </button>
        )} */}

        <CustomTable
          {...props}
          columns={[
            {
              title: "Company Name",
              render: (row) => row.application?.company_name || "N/A",
            },
            {
              title: "Location",
              render: (row) =>
                row.area_sub_table?.locations?.locations || "N/A",
            },
            {
              title: "Sub Location",
              render: (row) => row.area_sub_table?.sub_location || "N/A",
            },
            {
              title: "Built-up Space",
              render: (row) =>
                row.area_sub_table?.built_space_type?.name ||
                row.area_sub_table?.areasubs?.area_type_caption ||
                "N/A",
            },
            { title: "Allotted Space (Sq.ft)", field: "allotted_space" },
            { title: "Load Factor", field: "load_factor" },
            // { title: "Years", render: (row) => row.years || "-" },
            { title: "Rentable Amount", field: "total_amount" },
            { title: "Building Name", render: (row) => row.floor_name || "" }, // blank if not set
            { title: "Floor No", render: (row) => row.floor_no || "" }, // blank if not set

          ]}
          data={rentArea || []}
          actions={
            adminType === 2
              ? [
                { type: "edit", handleClick: handleEdit },
                // { type: "delete", handleClick: handleDelete },
              ]
              : [
                // { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },
              ]
          }
        />
      </div>
      {addNew && (
        <ManageBanner
          open={addNew}
          edit={edit}
          view={view}
          handleClose={handleClose}
          formData={formData}
        />
      )}
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Area ?"
          data={activeData}
          message="Are you sure to Delete this Area?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
